
import stringReverse from "./stringReverse";
import isObject from "./isObject";
import isArray from "./isArray";
import clone from "./clone";

export {
    stringReverse,
    isObject,
    isArray,
    clone
};
